import axios from 'axios';

export default axios.create({
  baseURL: `https://web.mbme.org/v1/`
});